var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Box, } from '@mui/material';
const BusinessModal = ({ open, business, onClose, onSave }) => {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
    });
    const [errors, setErrors] = useState({});
    useEffect(() => {
        if (business) {
            setFormData({
                name: business.name,
                description: business.description || '',
            });
        }
        else {
            setFormData({
                name: '',
                description: '',
            });
        }
        setErrors({});
    }, [business, open]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => (Object.assign(Object.assign({}, prev), { [name]: value })));
        if (errors[name]) {
            setErrors((prev) => (Object.assign(Object.assign({}, prev), { [name]: undefined })));
        }
    };
    const handleSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const newErrors = {};
        if (!((_a = formData.name) === null || _a === void 0 ? void 0 : _a.trim())) {
            newErrors.name = 'Business name is required';
        }
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        try {
            yield onSave(formData);
            onClose();
        }
        catch (error) {
            console.error('Error saving business:', error);
        }
    });
    return (_jsxs(Dialog, { open: open, onClose: onClose, maxWidth: "sm", fullWidth: true, children: [_jsx(DialogTitle, { children: business ? 'Edit Business' : 'Create New Business' }), _jsx(DialogContent, { children: _jsxs(Box, { sx: { pt: 2 }, children: [_jsx(TextField, { autoFocus: true, margin: "normal", name: "name", label: "Business Name", type: "text", fullWidth: true, required: true, value: formData.name || '', onChange: handleChange, error: !!errors.name, helperText: errors.name }), _jsx(TextField, { margin: "normal", name: "description", label: "Description", type: "text", fullWidth: true, multiline: true, rows: 4, value: formData.description || '', onChange: handleChange })] }) }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: onClose, children: "Cancel" }), _jsx(Button, { onClick: handleSubmit, variant: "contained", children: business ? 'Save' : 'Create' })] })] }));
};
export default BusinessModal;
